module.exports = __webpack_public_path__ + "img/73.acce2ea3.jpg";